export interface MangaChapter {
  id: string;
  mangaId: string;
  number: number;
  title: string;
  updateTime: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  rating: number;
  totalChapters: number;
  updateTime: string;
  tags: string[];
  status: '连载中' | '已完结';
  views: number;
  chapters: MangaChapter[];
}

export const mangaList: Manga[] = [
  {
    id: 'manga-1',
    title: '霸道总裁的甜心秘书',
    author: '韩小漫',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20romance%20cover%20illustration%20featuring%20a%20handsome%20CEO%20in%20a%20dark%20suit%20gazing%20at%20a%20cute%20female%20secretary%20with%20long%20brown%20hair%20wearing%20a%20formal%20office%20outfit%20soft%20pink%20background%20with%20floating%20rose%20petals%20romantic%20atmosphere%20clean%20composition%20delicate%20lineart&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    category: 'korean-romance',
    description: '刚毕业的林小柔进入顶级集团，成为了传说中冷酷无情的总裁秘书。本以为会过上被压榨的社畜生活，却发现总裁大人似乎对她格外温柔？原来三年前的那场意外相遇，早已在总裁心中埋下了爱情的种子。一段甜蜜又带点虐心的办公室恋情即将展开！',
    rating: 4.8,
    totalChapters: 86,
    updateTime: '2026-08-05',
    tags: ['恋爱', '总裁', '办公室', '甜宠'],
    status: '连载中',
    views: 1258000,
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      mangaId: 'manga-1',
      number: i + 1,
      title: `第${i + 1}话 ${i === 0 ? '意外的重逢' : i === 85 ? '最终话：永远的承诺' : ''}`,
      updateTime: new Date(2026, 7, 5 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-2',
    title: '重生之豪门千金',
    author: '星月工作室',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20fantasy%20romance%20cover%20art%20elegant%20noblewoman%20with%20flowing%20silver%20hair%20in%20a%20lavish%20gown%20standing%20in%20a%20palace%20ballroom%20with%20chandeliers%20soft%20golden%20and%20pastel%20pink%20color%20palette%20royal%20atmosphere%20detailed%20jewelry%20ornate%20frame%20composition&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    category: 'korean-fantasy',
    description: '前世被渣男贱女联手害死的豪门千金，意外重生回到十八岁。这一世，她要让所有欺负过她的人付出代价！更要找到那个在她最落魄时默默守护她的神秘男人。逆袭人生，从重生开始！',
    rating: 4.9,
    totalChapters: 120,
    updateTime: '2026-08-04',
    tags: ['重生', '豪门', '复仇', '逆袭'],
    status: '连载中',
    views: 2350000,
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      mangaId: 'manga-2',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 7, 4 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-3',
    title: '我的契约男友',
    author: '甜心漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20manhwa%20romance%20cover%20a%20cheerful%20young%20woman%20with%20short%20brown%20hair%20holding%20a%20contract%20paper%20smiling%20at%20a%20tall%20handsome%20man%20in%20casual%20clothing%20cherry%20blossom%20petals%20falling%20pastel%20pink%20and%20white%20background%20spring%20atmosphere%20clean%20illustration%20style&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    category: 'korean-romance',
    description: '为了应付家里的催婚，林悦和公司里最帅的男神签订了契约恋爱合同。原以为只是一场各取所需的交易，谁知假戏真做，两人的心越靠越近。但当契约到期的那一天来临，他们该如何面对这份意外的真心？',
    rating: 4.7,
    totalChapters: 65,
    updateTime: '2026-08-03',
    tags: ['契约恋爱', '假戏真做', '甜宠', '都市'],
    status: '连载中',
    views: 980000,
    chapters: Array.from({ length: 65 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      mangaId: 'manga-3',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 7, 3 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-4',
    title: '皇后的逆袭',
    author: '月下漫客',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20historical%20fantasy%20cover%20a%20fierce%20queen%20with%20long%20black%20hair%20in%20traditional%20hanbok%20style%20royal%20robe%20holding%20a%20sealed%20document%20standing%20in%20front%20of%20a%20throne%20dark%20red%20and%20gold%20accents%20palace%20interior%20atmosphere%20regal%20and%20powerful&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    category: 'korean-drama',
    description: '她是皇帝最不受宠的皇后，被冷落三年，甚至被废黜打入冷宫。但她没有认命！凭借过人的智慧和坚韧的意志，她一步步重返权力中心，让所有轻视她的人刮目相看。这是属于皇后的华丽逆袭！',
    rating: 4.9,
    totalChapters: 98,
    updateTime: '2026-08-02',
    tags: ['宫斗', '逆袭', '古风', '女强'],
    status: '连载中',
    views: 1870000,
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      mangaId: 'manga-4',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 7, 2 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-5',
    title: '邻家哥哥是恶魔',
    author: '樱花社',
    cover: 'https://readdy.ai/api/search-image?query=A%20playful%20school%20life%20romance%20manhwa%20cover%20a%20cute%20high%20school%20girl%20in%20uniform%20blushing%20while%20a%20handsome%20older%20boy%20next%20door%20teasingly%20pats%20her%20head%20cherry%20blossom%20tree%20in%20background%20soft%20pastel%20colors%20spring%20afternoon%20lighting%20warm%20and%20fluffy%20atmosphere&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    category: 'japanese-romance',
    description: '从小一起长大的邻家哥哥，在外人面前是品学兼优的完美学长，在她面前却变成了腹黑又爱捉弄人的恶魔！每天被各种欺负的小优，却在某天突然发现——原来哥哥做的一切，都是因为喜欢她？',
    rating: 4.6,
    totalChapters: 52,
    updateTime: '2026-08-04',
    tags: ['青梅竹马', '校园', '甜宠', '日常'],
    status: '已完结',
    views: 760000,
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      mangaId: 'manga-5',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 6, 15 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-6',
    title: '剑与魔法的恋人',
    author: '幻想工坊',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20fantasy%20adventure%20manhwa%20cover%20a%20female%20mage%20with%20long%20blue%20hair%20holding%20a%20glowing%20magic%20staff%20next%20to%20a%20handsome%20male%20knight%20with%20a%20sword%20magical%20runes%20floating%20around%20them%20starry%20night%20sky%20background%20mystical%20purple%20and%20silver%20tones&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    category: 'korean-fantasy',
    description: '天才魔法师莉娜在一次冒险中结识了沉默寡言的骑士团长卡尔。两人从最初的互不顺眼到并肩作战，在对抗黑暗势力的旅途中感情不断升温。当世界面临毁灭危机，他们能否用爱与勇气守护一切？',
    rating: 4.8,
    totalChapters: 72,
    updateTime: '2026-08-01',
    tags: ['奇幻', '冒险', '魔法', '战斗'],
    status: '连载中',
    views: 1120000,
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      mangaId: 'manga-6',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 7, 1 - Math.floor(i / 3)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-7',
    title: '杀手王妃不好惹',
    author: '暗夜文化',
    cover: 'https://readdy.ai/api/search-image?query=A%20cool%20action%20romance%20manhwa%20cover%20a%20beautiful%20female%20assassin%20in%20dark%20clothing%20with%20a%20dagger%20showing%20a%20confident%20smile%20moonlit%20rooftop%20scene%20behind%20her%20dark%20red%20and%20black%20color%20scheme%20with%20white%20moonlight%20highlights%20dramatic%20shadows%20stylish%20composition&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    category: 'korean-action',
    description: '现代顶级杀手意外穿越到古代，成为了和亲远嫁的王妃。本以为是换个地方继续杀人生涯，却遇到了温柔深情的王爷丈夫。在杀手的本能和妻子的柔情之间，她该如何抉择？',
    rating: 4.7,
    totalChapters: 110,
    updateTime: '2026-08-05',
    tags: ['穿越', '杀手', '古风', '女强'],
    status: '连载中',
    views: 1650000,
    chapters: Array.from({ length: 110 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      mangaId: 'manga-7',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 7, 5 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-8',
    title: '学渣少女的逆袭',
    author: '阳光漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20energetic%20school%20life%20manhwa%20cover%20a%20determined%20high%20school%20girl%20holding%20a%20test%20paper%20with%20a%20perfect%20score%20smiling%20brightly%20classroom%20setting%20with%20sunlight%20streaming%20through%20windows%20warm%20yellow%20and%20white%20color%20palette%20motivational%20atmosphere&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    category: 'japanese-shounen',
    description: '年级倒数第一的林小希，在遇到天才转学生陆辰后，人生发生了翻天覆地的变化。在陆辰的帮助下，她不仅成绩突飞猛进，更发现了自己隐藏的天赋。但当她终于站在顶峰时，却发现最珍贵的不是成绩，而是那段一起奋斗的时光。',
    rating: 4.5,
    totalChapters: 48,
    updateTime: '2026-07-28',
    tags: ['校园', '励志', '成长', '友情'],
    status: '已完结',
    views: 650000,
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      mangaId: 'manga-8',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 6, 28 - i).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-9',
    title: '恶魔少爷别吻我',
    author: '轻甜社',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20comedy%20manhwa%20cover%20a%20shy%20girl%20with%20pink%20cheeks%20being%20pulled%20close%20by%20a%20handsome%20arrogant%20young%20man%20in%20a%20luxurious%20mansion%20setting%20sparkling%20effects%20around%20them%20rose%20garden%20visible%20through%20window%20pastel%20pink%20and%20white%20color%20scheme&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    category: 'chinese-romance',
    description: '平凡女孩安初夏因为一笔意外债务，被迫住进了校草韩七录的豪宅。本以为会过上地狱般的生活，却在朝夕相处中发现了韩七录不为人知的温柔一面。但韩家的秘密和隐藏在背后的阴谋，让两人的感情之路布满荆棘。',
    rating: 4.8,
    totalChapters: 95,
    updateTime: '2026-08-03',
    tags: ['甜宠', '校园', '同居', '国产'],
    status: '连载中',
    views: 2100000,
    chapters: Array.from({ length: 95 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      mangaId: 'manga-9',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 7, 3 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-10',
    title: '影后的秘密情人',
    author: '星光娱乐',
    cover: 'https://readdy.ai/api/search-image?query=A%20glamorous%20showbiz%20romance%20manhwa%20cover%20a%20beautiful%20actress%20in%20a%20stunning%20evening%20gown%20on%20a%20red%20carpet%20looking%20back%20at%20a%20mysterious%20handsome%20man%20in%20the%20shadows%20camera%20flashes%20and%20spotlights%20elegant%20black%20and%20gold%20color%20palette%20Hollywood%20glamour%20atmosphere&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    category: 'korean-drama',
    description: '当红影后苏晚宁在人前是光芒万丈的女神，在人后却有着一段不为人知的秘密恋情。对方是娱乐圈最炙手可热的金牌经纪人，也是她最大的竞争对手。在名利场中守护爱情，究竟有多难？',
    rating: 4.6,
    totalChapters: 73,
    updateTime: '2026-08-01',
    tags: ['娱乐圈', '秘密恋爱', '都市', '甜虐'],
    status: '连载中',
    views: 1430000,
    chapters: Array.from({ length: 73 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      mangaId: 'manga-10',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 7, 1 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-11',
    title: '星之继承者',
    author: '银河漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20fantasy%20adventure%20manhwa%20cover%20a%20young%20hero%20with%20star-shaped%20pendant%20glowing%20standing%20on%20a%20floating%20platform%20among%20stars%20and%20nebula%20galaxy%20in%20background%20futuristic%20outfit%20silver%20and%20deep%20blue%20color%20scheme%20cosmic%20scale%20epic%20composition&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    category: 'korean-fantasy',
    description: '普通高中生林星辰在某天晚上看到了流星，许愿后竟然获得了操控星辰之力的能力！原来他体内流淌着远古星族的血脉。在逐渐掌握力量的过程中，来自星际的威胁也悄然降临。',
    rating: 4.7,
    totalChapters: 56,
    updateTime: '2026-07-30',
    tags: ['科幻', '异能', '热血', '冒险'],
    status: '连载中',
    views: 890000,
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      mangaId: 'manga-11',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 6, 30 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
  {
    id: 'manga-12',
    title: '恋与制作人',
    author: '心动工作室',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20modern%20office%20manhwa%20cover%20a%20creative%20female%20game%20producer%20with%20glasses%20surrounded%20by%20four%20handsome%20men%20in%20different%20styles%20casual%20office%20setting%20with%20computer%20screens%20soft%20warm%20lighting%20pastel%20mint%20and%20peach%20color%20scheme%20otome%20game%20vibes&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    category: 'chinese-romance',
    description: '身为游戏制作人的苏晓，负责开发一款恋爱模拟游戏。为了找到完美的角色原型，她开始与四位风格迥异的男神接触。却没想到，游戏中的剧情竟然在现实中一一上演，而她成了自己故事里的女主角！',
    rating: 4.8,
    totalChapters: 82,
    updateTime: '2026-08-04',
    tags: ['乙女', '都市', '甜宠', '国产'],
    status: '连载中',
    views: 1780000,
    chapters: Array.from({ length: 82 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      mangaId: 'manga-12',
      number: i + 1,
      title: `第${i + 1}话`,
      updateTime: new Date(2026, 7, 4 - Math.floor(i / 2)).toISOString().split('T')[0],
    })),
  },
];

export const mangaMap: Record<string, Manga> = {};
mangaList.forEach((manga) => {
  mangaMap[manga.id] = manga;
});

export function getMangaByCategory(slug: string): Manga[] {
  return mangaList.filter((manga) => manga.category === slug);
}

export function getFeaturedManga(): Manga[] {
  return mangaList.slice(0, 6);
}

export function getLatestManga(): Manga[] {
  return [...mangaList].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());
}

export function getHotManga(): Manga[] {
  return [...mangaList].sort((a, b) => b.views - a.views).slice(0, 8);
}